import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import { useProjectEntity } from '@/hooks/useProjectEntity';
import { projectEntityQueryKey } from '@/lib/projectEntityCache';

/**
 * Проект по id: из entity-кэша (его держат списки и realtime), а если там нет (прямая ссылка, проект из сообщения чата) —
 * загружается в тот же кэш. query — для ошибки: 404 — проект удалён, остальное — нет доступа или сети.
 */
export function useProjectById(projectId: string) {
  const cached = useProjectEntity(projectId);
  const query = useQuery({
    queryKey: projectEntityQueryKey(projectId),
    queryFn: () => api.projects.get(projectId),
    enabled: !cached,
  });
  return { project: cached ?? query.data, query };
}
